import { render, staticRenderFns } from "./UnsavedChangesNotify.vue?vue&type=template&id=358c10fc"
import script from "./UnsavedChangesNotify.vue?vue&type=script&lang=js"
export * from "./UnsavedChangesNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports